<template>
    <div class="py-10">
        <div>
            <div class="text-center">
                <span :class="channel.platform ? channel.platform.icon : ''" style="color: var(--magic-color);font-size: 60px;margin-bottom: 10px;color: var(--magic-color)"></span>
                <p>

                    <a
                        class="InfluencerProfileChannelsTab__channel__value"
                        :href="channel.resource_url"
                        target="_blank"
                        @click.stop=""
                    >
                        <span v-if="channel.platform.slug === 'blog'" class="break-all" v-text="channel.resource_name" />
                        <span v-else class="break-all" v-text="'@'+channel.resource_name" />
                        <span class="fa fa-external-link" />
                    </a>
                </p>
            </div>

            <div class="text-center pt-10 w-full">
                <p
                    class=""
                    style="
                        font-size: 40px;
                    "
                    v-text="channel.reach"
                />
                <p
                    class=""
                    style="color: var(--magic-color)"
                    v-text="channel.platform.reach_name"
                />
            </div>
        </div>
        <div>
            <InstagramBusinessChannelStatistics
                v-if="channel.platform.slug === 'instagram_business'"
                class="pt-5"
                v-bind="{ channel, contents }"
            />
            <!--
            <div v-else class="text-center">
                Der er ingen yderligere statistik at vise for dette medie.
            </div>
            -->
        </div>
    </div>
</template>

<script>
import InstagramBusinessChannelStatistics from 'dashboard-js/components/influencers/InstagramBusinessChannelStatistics'

export default {
    components: {
        InstagramBusinessChannelStatistics,
    },

    props: ['channel'],

    computed: {
        contents() {
            return this.channel.contents.filter(value => value.latest_stat !== null)
        },
    },
}
</script>
